import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class SpriteLabel extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, type) {
    super(scene);

    this.bg = this.scene.add.rectangle(0, 0, 195, 83, 0xf99f1c);
    this.add(this.bg);

    if (type === 1) {
      this.header = ABCyaPhaser.Text.addText(2, -11, 18, 0xffd730, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.label_header'), this).setOrigin(0.5)
        .setWordWrapWidth(175);
      ABCyaPhaser.Text.resizeFontToFitWidth(this.header, 175, 50);
      this.triesLabel = ABCyaPhaser.Text.addText(14, 26, `${14}pt`, 0xd25f1c, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.tries_label'), this).setOrigin(1, 0.5);
      this.textLabel4 = ABCyaPhaser.Text.addText(20, 27, `${14}pt`, 0xd05f28, FontKeys._odin_roundedregular, '0', this).setOrigin(0, 0.5);
    }
    else if (type === 2) {
      this.header = ABCyaPhaser.Text.addText(2, -11, 18, 0xffd730, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.assembly_header'), this).setOrigin(0.5)
        .setWordWrapWidth(175);
      ABCyaPhaser.Text.resizeFontToFitWidth(this.header, 175, 50);
      this.triesLabel = ABCyaPhaser.Text.addText(14, 26, `${14}pt`, 0xd25f1c, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.tries_label'), this).setOrigin(1, 0.5);
      this.textLabel4 = ABCyaPhaser.Text.addText(20, 28, `${14}pt`, 0xd05f28, FontKeys._odin_roundedregular, '0', this).setOrigin(0, 0.5);
    }
  }

  setValue(value) {
    this.textLabel4.text = value;
  }
}